export default "__VITE_ASSET__DR4h0XAG__"